export const blue = '#154988';
export const orange = '#e69a2b';
export const darkGrey = '#646464';
export const white = '#ffffff';
